import React, { useEffect, useState } from 'react';
import './login.css';
import axios from "axios";
import BaseUrl from '../../base-api';
import { toast } from 'react-toastify';
import imgpath from './../../assets/hsdm.png';
import Cookies from 'js-cookie';
import { saveAs } from 'file-saver';
import Loader from "../Loader/Loader";
const Login = () => {
  const [data, setData] = useState({
    adhaar: '',
    captcha: ''
  });
  const [loading, setLoading] = useState(false);
  const [img, setImg] = useState(imgpath);

  useEffect(() => {
    fetchData();
  }, []);




  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "adhaar") {
      value = value.replace(/\D/g, "");
      if (value.length > 12) value = value.slice(0, 12);
    } else if (name === "captcha") {
      value = value.replace(/[^a-zA-Z0-9]/g, "");
      if (value.length > 6) value = value.slice(0, 6);
    }

    setData({ ...data, [name]: value });
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const jsessionid = Cookies.get('JSESSIONID');
      const res = await axios.get(`${BaseUrl}/api/auth/captcha`, {
        headers: {
          'Content-Type': 'application/json',
          ...(jsessionid && { Cookie: `JSESSIONID=${jsessionid}` }),
        },
        withCredentials: true,
      });

      if (res) {
        setImg(`data:image/png;base64,${res.data}`)

      }

    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    finally {
      setLoading(false);
    }
  };
  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      const formData = {
        username: data.adhaar,
        captcha: data.captcha,
      };
      const jsessionid = Cookies.get('JSESSIONID');
      const res = await axios.post(`${BaseUrl}/api/auth/download`, formData, {
        headers: {
          'Content-Type': 'application/json',
          ...(jsessionid && { Cookie: `JSESSIONID=${jsessionid}` }),
        },
        withCredentials: true,
        responseType: 'blob', 
      });
  
      if (res && res.data) {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        saveAs(blob, 'admit_card.pdf'); 
      }
    } catch (error) {
      console.error('Download error:', error);
      toast.error(error.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
      fetchData();
    } 
  }


  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="loginDiv">
          <div
            className="login-container"
            style={{
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              borderRadius: "8px",
            }}
          >
            <h2 style={{ color: "grey" }}>Download Admit Card</h2>
            <form autoComplete='off'>
              <div className="form-group">
                <label>Aadhaar Number:</label>

                <input
                  type="text"
                  name="adhaar"
                  value={data.adhaar}
                  onChange={handleChange}
                  placeholder="Enter your Aadhaar Number" 
                  onPaste={(e) => e.preventDefault()}
                />
              </div>
              <img width={160} src={img} />
              <div className="form-group">
                <label>Enter Captcha:</label>
                <input
                  type="text"
                  name="captcha"
                  value={data.captcha}
                  onChange={handleChange}
                  placeholder="Enter above Captcha"
                  onPaste={(e) => e.preventDefault()}
                />
              </div>

              <button type="button" onClick={handleSubmit}>
                Verify
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
